import { useForm } from 'react-hook-form';
import {
  ImportAccountingDoctorAttendingCsvFormValues,
  importAccountingDoctorAttendingCsvFormResolver,
} from './schema';

export type ImportAccountingDoctorAttendingCsvUseForm = ReturnType<
  typeof useForm<ImportAccountingDoctorAttendingCsvFormValues>
>;

export const useImportAccountingDoctorAttendingCsvForm = (
  defaultValues?: Partial<ImportAccountingDoctorAttendingCsvFormValues>,
) => {
  const importAccountingDoctorAttendingCsvForm =
    useForm<ImportAccountingDoctorAttendingCsvFormValues>({
      resolver: importAccountingDoctorAttendingCsvFormResolver,
      defaultValues: {
        ...defaultValues,
      },
    });

  return { importAccountingDoctorAttendingCsvForm };
};
